import { combineReducers } from '@reduxjs/toolkit'
import { authApi } from '@/features/auth/auth.api.ts'
import { authSlice } from '@/features/auth/auth.slice.ts'
import { invoicesAllocationApi } from '@/pages/invoices-allocation/api'
import { deferredBonusesApi } from '@/pages/deferred-bonuses/api'
import { agGridStateApi } from '@/features/ag-grid-state/ag-grid-state.api.ts'
import { userMessagesApi } from '@/features/user-messages/user-messages.api.ts'

export const appReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [invoicesAllocationApi.reducerPath]: invoicesAllocationApi.reducer,
  [deferredBonusesApi.reducerPath]: deferredBonusesApi.reducer,
  [agGridStateApi.reducerPath]: agGridStateApi.reducer,
  [userMessagesApi.reducerPath]: userMessagesApi.reducer,
  auth: authSlice.reducer,
})
